import { render, staticRenderFns } from "./IconDrag.vue?vue&type=template&id=34acd97a&"
import script from "./IconDrag.vue?vue&type=script&lang=js&"
export * from "./IconDrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34acd97a')) {
      api.createRecord('34acd97a', component.options)
    } else {
      api.reload('34acd97a', component.options)
    }
    module.hot.accept("./IconDrag.vue?vue&type=template&id=34acd97a&", function () {
      api.rerender('34acd97a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconDrag.vue"
export default component.exports